// DropdownField.jsx - FIXED VERSION
import React from 'react';
import { Form } from 'react-bootstrap';

const DropdownField = ({ controlId, label, name, value, options, handleChange, error, isRequired, style, className }) => {
    // Function to normalize options - handles both string arrays and object arrays
    const normalizeOptions = (opts) => {
        if (!opts || opts.length === 0) return [];

        return opts.map((option, index) => {
            // If option is already an object with value and label, use it as is
            if (typeof option === 'object' && option !== null && 'value' in option && 'label' in option) {
                return option;
            }
            // If option is a string, create an object with value and label
            return {
                value: option,
                label: option
            };
        });
    };

    const normalizedOptions = normalizeOptions(options);

    return (
        <Form.Group controlId={controlId}>
            <Form.Label>
                {label}
                {isRequired && <span className="text-danger"> *</span>}
            </Form.Label>
            <Form.Select
                name={name}
                value={value}
                onChange={handleChange}
                isInvalid={!!error}
                style={style}
                className={className}
            >
                <option value="">Select...</option>
                {normalizedOptions.map((option, index) => (
                    <option key={index} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </Form.Select>
            {error && (
                <Form.Control.Feedback type="invalid">
                    {error}
                </Form.Control.Feedback>
            )}
        </Form.Group>
    );
};

export default DropdownField;